export default "__VITE_ASSET__CSX4GVmf__"